import React, { ErrorInfo, ReactNode } from 'react';

interface Props {
	/**
	 * The react node, or element, to display on error
	 */
	fallback: ReactNode;
	children: ReactNode;
}

interface State {
	/**
	 * Whether or not an error has been caught
	 */
	hasError: boolean;
}

/**
 * Handles errors which propagate from descendant components. Will
 * display a 'fallback' element on error, and log the error to the console.
 */
export class ErrorBoundary extends React.Component<Props, State> {
	constructor(
		readonly props: Props,
		public state: State = { hasError: false }
	) {
		super(props);
	}

	componentDidCatch(error: Error, _errorInfo: ErrorInfo): void {
		this.setState({ hasError: true });
		console.error(error);
	}

	render(): ReactNode {
		if (this.state.hasError) {
			return this.props.fallback;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
